import type { Asset } from '@frameio/graphql-client/generated';
import { useActiveAssetId } from '../contexts/ActiveEntitiesContext/ActiveAssetIdContext';
import { useActiveVersionId } from '../contexts/ActiveEntitiesContext/ActiveVersionIdContext';
import {
  useActiveMediaStateIndex,
  useComparisonAssetIds,
} from '../contexts/ComparisonAssetsContext/ComparisonAssetsContext';

/**
 * A util hook to grab the active asset id that is viewable in the
 * media viewer and/or active in the comparison viewer
 * (this should never be a VersionStackAsset or FolderAsset)
 */
export const useActiveViewableAssetId = (): Asset['id'] => {
  const assetId = useActiveAssetId();
  const versionId = useActiveVersionId();
  const comparisonIds = useComparisonAssetIds();
  const activeIndex = useActiveMediaStateIndex();

  return comparisonIds[activeIndex] || versionId || assetId;
};
